import * as React from "react";
import "./App.css";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";
import { connectorsForWallets, wallet } from "@rainbow-me/rainbowkit";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { chain, configureChains, createClient, WagmiConfig } from "wagmi";
import { publicProvider } from "wagmi/providers/public";
import { usePrepareSendTransaction, useSendTransaction } from "wagmi";

export function SendTransaction() {
  const [to, setTo] = React.useState(
    "0x029559467c12Ac8173c387da6e4C66e4A6C8aF61"
  );

  const [amount, setAmount] = React.useState(0);

  const { config } = usePrepareSendTransaction({
    request: {
      to: to,
    },
  });
  const { sendTransaction } = useSendTransaction(config);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        sendTransaction?.();
      }}
    >
      <button className="sendEthButton btn">Send</button>
    </form>
  );
}

const { chains, provider } = configureChains(
  [chain.mainnet],
  [publicProvider()]
);

const connectors = connectorsForWallets([
  {
    groupName: "Recommended",
    wallets: [wallet.metaMask({ chains })],
  },
]);
const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

function App() {
  return (
    <WagmiConfig client={wagmiClient}>
      <RainbowKitProvider chains={chains}>
        <div className="App">
          <header className="App-header">
            <div className="outer-container">
              <div className="browser-container">
                <div className="row">
                  <div className="column left">
                    <span
                      className="dot"
                      style={{ background: "#ED594A" }}
                    ></span>
                    <span
                      className="dot"
                      style={{ background: "#FDD800" }}
                    ></span>
                    <span
                      className="dot"
                      style={{ background: "#5AC05A" }}
                    ></span>
                  </div>
                  <div className="column middle">
                    <input
                      type="text"
                      value="http://www.testwebsite.com"
                    ></input>
                  </div>
                  <div className="column right">
                    <img
                      className="stelo-icon"
                      src="https://files.umso.co/lib_miIysDMakpgLLDjI/qg4rvf6cuobbn9fu.png?w=44"
                      width="16"
                    ></img>
                    <div style={{ float: "right" }}>
                      <span className="bar"></span>
                      <span className="bar"></span>
                      <span className="bar"></span>
                    </div>
                  </div>
                </div>

                <div className="content">
                  <div className="eth-buttons">
                    <h3>First, connect your wallet</h3>
                    <ConnectButton />
                  </div>
                  <h3>Next, send a test transaction for 0 ETH.</h3>
                  <p>
                    {" "}
                    Don't worry, we set the gas to 0 so it won't actually allow
                    you to send it in MetaMask.
                  </p>
                  <div className="eth-buttons">
                    <SendTransaction />
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
      </RainbowKitProvider>
    </WagmiConfig>
  );
}

export default App;
